import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.14645 2.14645C9.34171 1.95118 9.65822 1.95118 9.85348 2.14645C10.0487 2.34171 10.0487 2.65822 9.85348 2.85348L6.70699 5.99996L9.85348 9.14645L9.88766 9.18453C10.0478 9.38092 10.0365 9.67042 9.85348 9.85348C9.67042 10.0365 9.38092 10.0478 9.18453 9.88766L9.14645 9.85348L5.99996 6.70699L2.85348 9.85348C2.65822 10.0487 2.34171 10.0487 2.14645 9.85348C1.95118 9.65822 1.95118 9.34171 2.14645 9.14645L5.29293 5.99996L2.14645 2.85348C1.95118 2.65822 1.95118 2.34171 2.14645 2.14645C2.34171 1.95118 2.65822 1.95118 2.85348 2.14645L5.99996 5.29293L9.14645 2.14645Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.1953 2.86225C12.4557 2.6019 12.8777 2.6019 13.1381 2.86225C13.3984 3.1226 13.3984 3.54461 13.1381 3.80496L8.94274 8.00028L13.1381 12.1956L13.1836 12.2464C13.3972 12.5082 13.3821 12.8942 13.1381 13.1383C12.894 13.3824 12.508 13.3974 12.2461 13.1839L12.1953 13.1383L8.00003 8.94298L3.80472 13.1383C3.54437 13.3986 3.12236 13.3986 2.86201 13.1383C2.60166 12.8779 2.60166 12.4559 2.86201 12.1956L7.05732 8.00028L2.86201 3.80496C2.60166 3.54461 2.60166 3.1226 2.86201 2.86225C3.12236 2.6019 3.54437 2.6019 3.80472 2.86225L8.00003 7.05757L12.1953 2.86225Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.2441 3.57709C15.5696 3.25165 16.0971 3.25165 16.4225 3.57709C16.7479 3.90252 16.7479 4.43003 16.4225 4.75547L11.1784 9.99961L16.4225 15.2438L16.4795 15.3072C16.7464 15.6345 16.7276 16.117 16.4225 16.4221C16.1174 16.7272 15.6349 16.7461 15.3076 16.4791L15.2441 16.4221L9.99998 11.178L4.75584 16.4221C4.4304 16.7476 3.90289 16.7476 3.57745 16.4221C3.25201 16.0967 3.25201 15.5692 3.57745 15.2438L8.82159 9.99961L3.57745 4.75547C3.25201 4.43003 3.25201 3.90252 3.57745 3.57709C3.90289 3.25165 4.4304 3.25165 4.75584 3.57709L9.99998 8.82123L15.2441 3.57709Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.14645 2.14645C9.34171 1.95118 9.65822 1.95118 9.85348 2.14645C10.0487 2.34171 10.0487 2.65822 9.85348 2.85348L6.70699 5.99996L9.85348 9.14645L9.88766 9.18453C10.0478 9.38092 10.0365 9.67042 9.85348 9.85348C9.67042 10.0365 9.38092 10.0478 9.18453 9.88766L9.14645 9.85348L5.99996 6.70699L2.85348 9.85348C2.65822 10.0487 2.34171 10.0487 2.14645 9.85348C1.95118 9.65822 1.95118 9.34171 2.14645 9.14645L5.29293 5.99996L2.14645 2.85348C1.95118 2.65822 1.95118 2.34171 2.14645 2.14645C2.34171 1.95118 2.65822 1.95118 2.85348 2.14645L5.99996 5.29293L9.14645 2.14645Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.1953 2.86225C12.4557 2.6019 12.8777 2.6019 13.1381 2.86225C13.3984 3.1226 13.3984 3.54461 13.1381 3.80496L8.94274 8.00028L13.1381 12.1956L13.1836 12.2464C13.3972 12.5082 13.3821 12.8942 13.1381 13.1383C12.894 13.3824 12.508 13.3974 12.2461 13.1839L12.1953 13.1383L8.00003 8.94298L3.80472 13.1383C3.54437 13.3986 3.12236 13.3986 2.86201 13.1383C2.60166 12.8779 2.60166 12.4559 2.86201 12.1956L7.05732 8.00028L2.86201 3.80496C2.60166 3.54461 2.60166 3.1226 2.86201 2.86225C3.12236 2.6019 3.54437 2.6019 3.80472 2.86225L8.00003 7.05757L12.1953 2.86225Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.2442 3.57709C15.5697 3.25165 16.0972 3.25165 16.4226 3.57709C16.7481 3.90252 16.7481 4.43003 16.4226 4.75547L11.1785 9.99961L16.4226 15.2438L16.4796 15.3072C16.7466 15.6345 16.7277 16.117 16.4226 16.4221C16.1175 16.7272 15.635 16.7461 15.3077 16.4791L15.2442 16.4221L10.0001 11.178L4.75596 16.4221C4.43052 16.7476 3.90301 16.7476 3.57757 16.4221C3.25214 16.0967 3.25214 15.5692 3.57757 15.2438L8.82171 9.99961L3.57757 4.75547C3.25214 4.43003 3.25214 3.90252 3.57757 3.57709C3.90301 3.25165 4.43052 3.25165 4.75596 3.57709L10.0001 8.82123L15.2442 3.57709Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconXClose: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"x-close"} {...props} />
);
